/**
 * Copyright (c) 2025 Kalpit Patel
 *
 * Sole Developer and Owner:
 * Kalpit Patel is the sole developer and creator of this entire application.
 * No other individual or entity has contributed to the development of this software.
 * All rights reserved.
 *
 * This file is part of AksharJobs application.
 */

import React from 'react';

const Pricing = () => {
  return (
    <div className="static-page-container">
      <div className="static-page-content">
        <h1 className="page-title">Pricing</h1>

        <div className="pricing-section">
          <h2>AksharJobs is 100% Free</h2>
          <p>
            AksharJobs is completely free for everyone on the platform.
            There are no hidden charges, no monthly subscriptions, and no trial limitations.
          </p>
        </div>

        <div className="pricing-section">
          <h2>For Job Seekers</h2>
          <ul className="features-list">
            <li>✓ Create your profile for free</li>
            <li>✓ Search and apply to jobs for free</li>
            <li>✓ Access recommendations and platform tools for free</li>
          </ul>
        </div>

        <div className="pricing-section">
          <h2>For Employers</h2>
          <ul className="features-list">
            <li>✓ Post jobs for free</li>
            <li>✓ Discover and connect with candidates for free</li>
            <li>✓ Use core hiring features at no cost</li>
          </ul>
        </div>

        <div className="pricing-section">
          <h2>Simple and Transparent</h2>
          <p>
            Our goal is to make hiring and job discovery accessible to everyone.
            If we introduce any optional paid features in the future, we will clearly communicate
            them in advance on this page.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
